import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "../components/toast";
import { useToast } from "./use-toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, ...props }) => (
        <Toast key={id} {...props}>
          <div className="flex flex-col gap-1 w-full">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastDescription className="max-w-full">{description}</ToastDescription>}
          </div>
          {action}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
